import React, { Fragment, useState } from 'react';
import CustomButton from '../../CustomButton';

import { Col } from 'react-bootstrap';
import { TextField } from '@mui/material';
import {
  validNumber,
  disableInput,
  generateLabel,
  generateInput,
  emptyNotEmpty,
  getFirstRadioButton,
} from '../attribute-utils';
import { attributeTypes } from '../../../../utils/search';
import FilterContainerMenu from './FilterContainerMenu';
import { formatDate } from '../../../../utils/date';

const FilterContainer = (props) => {
  const {
      Placeholders,
      filterAttributes,
      changeState,
      enums,
      state,
      radioButtons,
      removeChosenAttribute,
      setOpenedFilter,
      openedFilter,
      t,
    } = props || {},
    { attribute, error } = state || {};

  const [showFirstFilter, setShowFirstFilter] = useState(false);

  const onChangeShowFirstFilter = () => {
    setOpenedFilter(attribute?.label);
    setShowFirstFilter(true);
  };

  const closeFilter = () => {
    setOpenedFilter(null);
  };

  const onChangeFirstCriteria = (event) => {
    changeState('firstCriteria', event.target.value);
    if (emptyNotEmpty(enums, event.target.value)) {
      changeState('firstInput', '');
    }
  };

  const onChangeFirstInput = (event) => {
    if (
      attribute?.type === attributeTypes.NUMBER &&
      !validNumber(event.target.value)
    ) {
      changeState('firstInput', '');
      return;
    }
    if (isLongerThanAllowed(event)) return;
    changeState('firstInput', event.target.value);
    if (!event.target.value) {
      changeState('secondInput', '');
      changeState('secondCriteria', filterAttributes[0]);
      changeState('radioOption', getFirstRadioButton(radioButtons)?.value);
    }
  };

  const onChangeFirstInputRange = (event) => {
    changeState('firstInputRange', event.target.value);
  };

  const onChangeSecondCriteria = (event) => {
    changeState('secondCriteria', event.target.value);
    if (emptyNotEmpty(enums, event.target.value)) {
      changeState('secondInput', '');
    }
  };

  function isLongerThanAllowed(event) {
    return (
      attribute?.type === attributeTypes.TEXT &&
      attribute?.maxLength &&
      event.target.value.length > attribute?.maxLength
    );
  }

  const onChangeSecondInput = (event) => {
    if (
      attribute?.type === attributeTypes.NUMBER &&
      !validNumber(event.target.value)
    ) {
      changeState('secondInput', '');
      return;
    }

    if (isLongerThanAllowed(event)) return;
    changeState('secondInput', event.target.value);
  };

  const onChangeSecondInputRange = (event) => {
    changeState('secondInputRange', event.target.value);
  };

  const onChangeInput = (event) => {
    if (
      attribute?.type === attributeTypes.NUMBER &&
      !validNumber(event.target.value)
    ) {
      return;
    }
    if (isLongerThanAllowed(event)) return;

    changeState('firstInput', event.target.value);
  };

  const onChangeFirstComboBox = (value) => {
    changeState('firstInput', value);
  };

  const onChangeSecondComboBox = (value) => {
    changeState('secondInput', value);
  };

  const onChangeFirstDate = (event) => {
    changeState('firstInput', formatDate(event));
  };

  const onChangeSecondDate = (event) => {
    changeState('secondInput', formatDate(event));
  };

  const onChangeRadioOption = (event) => {
    changeState('radioOption', event.target.value);
  };

  const isFilterBlockHidden = !(
    openedFilter === attribute?.label && showFirstFilter
  );

  return (
    <Fragment>
      <Col md={3} className="position-relative mb-19">
        <CustomButton
          key={attribute?.label}
          className={'default-btn-light w-100 p-0 btn-sm'}
          label={Placeholders.filter}
          startIcon={<i className="fa-solid fa-filter font-size-14"></i>}
          onClick={onChangeShowFirstFilter}
          size="small"
        />
        <div
          role="button"
          className="filter-content-block"
          hidden={isFilterBlockHidden}
        >
          <div className="filter-content-block-header" onClick={closeFilter}>
            <i className="fa-solid fa-filter cursor-pointer"></i>
          </div>
          <div className="filter-content-block-body">
            <FilterContainerMenu
              key={attribute?.label}
              state={state}
              filterAttributes={filterAttributes}
              enums={enums}
              onChangeFirstCriteria={onChangeFirstCriteria}
              onChangeFirstComboBox={onChangeFirstComboBox}
              onChangeFirstDate={onChangeFirstDate}
              onChangeFirstInput={onChangeFirstInput}
              onChangeFirstInputRange={onChangeFirstInputRange}
              radioButtons={radioButtons}
              onChangeRadioOption={onChangeRadioOption}
              onChangeSecondCriteria={onChangeSecondCriteria}
              onChangeSecondComboBox={onChangeSecondComboBox}
              onChangeSecondDate={onChangeSecondDate}
              onChangeSecondInput={onChangeSecondInput}
              onChangeSecondInputRange={onChangeSecondInputRange}
              t={t}
            />
          </div>
        </div>
      </Col>
      <Col md={6} className="mb-19 pt-2 d-flex pr-none">
        <TextField
          key={attribute?.label}
          name="filterInput"
          size="small"
          className="smaller-input filter-content-block-body filter-input"
          value={generateInput(enums, radioButtons, state, Placeholders)}
          onChange={onChangeInput}
          label={error || generateLabel(enums, radioButtons, state)}
          InputLabelProps={{ shrink: true }}
          disabled={disableInput(enums, state)}
          error={error?.length > 0}
        />
        <div
          className={'ml-10'}
          onClick={() => {
            removeChosenAttribute(attribute);
          }}
        >
          <i className="fa-solid fa-xmark cursor-pointer pt-5" />
        </div>
      </Col>
    </Fragment>
  );
};

export default FilterContainer;
